import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=4a87af31&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=4a87af31&prod&scoped=true&lang=css&external"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=4a87af31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87af31",
  null
  
)

export default component.exports